import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { valueRender } from '@repo/toolkit/conditional-render'
import { DateFormatter } from '@repo/toolkit/date'
import { StringFormatter } from '@repo/toolkit/string'
import { Column } from '@repo/ui/data-table'
import { StarIcon } from '@repo/ui/icons'

import { genderOneLetterMapping } from '../../../lib/types/enums/common/gender.enum'
import { EnrollmentProperties } from '../../../lib/types/models/enrollment/enrollment.properties'
import { TripProperties } from '../../../lib/types/models/trip/properties.trip'
import { TripBookingDispatchPlaceIndividualTypeEnum } from '../../../lib/types/models/trip-booking/trip-date'
import { TripBookingDispatchPlace } from '../../../lib/types/models/trip-booking-dispatch-places/trip-booking-dispatch-place'
import { TripBookingDispatchPlaceProperties } from '../../../lib/types/models/trip-booking-dispatch-places/trip-booking-dispatch-place.properties'
import { QualificationTags } from '../../elements/qualification-badge'

export const enrollmentColumns: Column<TripBookingDispatchPlace>[] = [
  {
    accessorKey: '',
    columnHeaderClassName: 'rounded-tl-lg',
    header: 'Nom',
    accessorFn: (row) => valueRender(row.enrollment?.childLastName, (l) => l.toUpperCase())
  },
  {
    accessorKey: '',
    header: 'Prénom',
    accessorFn: (row) =>
      valueRender(row.enrollment?.childFirstName, (f) => StringFormatter.capitalize(f))
  },
  {
    accessorKey: '',
    header: 'Ami(s)',
    accessorFn: (row) =>
      valueRender(row.enrollment?.blockedFriends, (friends) =>
        friends
          .map((friend) =>
            valueRender(friend.firstName, (firstName) => StringFormatter.capitalize(firstName))
          )
          .join(', ')
      )
  },
  {
    accessorKey: '',
    header: 'Voyage secondaire',
    accessorFn: (row) =>
      valueRender(row.enrollment?.mainProposition.secondaryTrip, (t) =>
        TripProperties.getTripLabel(t)
      )
  },
  {
    accessorKey: '',
    header: 'Âge',
    accessorFn: (row) => EnrollmentProperties.getAgeAtDeparture(row.enrollment)?.toString() ?? '-'
  },
  {
    accessorKey: '',
    header: 'Sexe',
    accessorFn: (row) => genderOneLetterMapping[row.enrollment?.childGender ?? 'NONE'].label
  },
  {
    accessorKey: '',
    header: 'AA',
    columnHeaderClassName: 'rounded-tr-lg',
    cell: ({ row }) =>
      row.original.enrollment?.isAA && (
        <div className={'bg-yellow-light rounded-full p-1 w-fit'}>
          <StarIcon filled color={tailwindColors.yellow.DEFAULT} />
        </div>
      )
  }
]

export const staffColumns: Column<TripBookingDispatchPlace>[] = [
  {
    accessorKey: '',
    columnHeaderClassName: 'rounded-tl-lg',
    header: 'Nom',
    accessorFn: (row) => {
      if (row.individualType === TripBookingDispatchPlaceIndividualTypeEnum.ENROLLMENT) return '-'
      return TripBookingDispatchPlaceProperties.getStaffInformation(row).lastName?.toUpperCase()
    }
  },
  {
    accessorKey: '',
    header: 'Prénom',
    accessorFn: (row) =>
      StringFormatter.capitalize(
        TripBookingDispatchPlaceProperties.getStaffInformation(row).firstName
      )
  },
  {
    accessorKey: '',
    header: 'Qualification',
    cell: ({ row }) => {
      if (row.original.individualType === TripBookingDispatchPlaceIndividualTypeEnum.ENROLLMENT)
        return '-'
      return (
        <QualificationTags
          qualifications={TripBookingDispatchPlaceProperties.getHiredQualifications(row.original)}
        />
      )
    }
  },
  {
    accessorKey: '',
    header: 'Âge',
    accessorFn: (row) =>
      valueRender(row.affectedStaff?.staff.birthDate, (d) =>
        DateFormatter.calculateAge(d).toString()
      )
  },
  {
    accessorKey: '',
    header: 'Sexe',
    accessorFn: (row) =>
      valueRender(
        row.affectedStaff?.staff.gender,
        (g) => genderOneLetterMapping[g ?? 'NONE'].label
      )
  },
  {
    accessorKey: '',
    header: 'N° de mobile person',
    columnHeaderClassName: 'rounded-tr-lg',
    accessorFn: (row) => TripBookingDispatchPlaceProperties.getStaffInformation(row).phoneNumber
  }
]
